var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout default-layout"},[_c('Header'),_c('div',{staticClass:"app-content"},[_vm._t("default")],2),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }